import { DOM } from '../core/dom';

export namespace AdminHeader {
  export function onload(): void {
    const header = DOM.byId('top-header');
    const mobileMenu = DOM.byId('mobile-menu');
    mobileMenu.addEventListener('click', () => {
      if (header.classList.contains('expanded')) {
        header.classList.remove('expanded');
      } else {
        header.classList.add('expanded');
      }
    });
  }
}